import b2b from 'back-to-basic';
import { DOMAIN_TLDS } from './constants';

export function stripWWW(name: string): string {
  return name.replace(/^www\./, '');
}

export function stripProtocol(name: string): string {
  return name.replace(/^https?:\/\//, '');
}

export function extractKnownTld(
  domain: string,
  tldList: string[] = DOMAIN_TLDS
): string {
  const cleanedDomain = stripWWW(stripProtocol(domain));
  const tldMatches = cleanedDomain.match(/^([^.]+)(.*)/);
  if (!tldMatches) {
    return null as string;
  }

  const [, , tld] = tldMatches;
  if (tldList.indexOf(tld) === -1) {
    return extractKnownTld(tld.substring(1), tldList);
  }

  return tld;
}

interface SplittedTldPayload {
  domain: string;
  tld: string;
}
export function splitTldFromDomain(domain: string): SplittedTldPayload {
  const tld = extractKnownTld(domain);
  if (!tld) {
    return { domain, tld: null };
  }
  domain = domain.substring(0, domain.length - tld.length);
  return { domain, tld };
}

export function transformSpecialCharacters(name: string): string {
  return b2b(name)
    .replace(/[_.]/g, () => '-') // transform . and _ to -
    .replace(/[^\w-]/g, '') // remove all non word characters with dashes
    .replace(/-+/g, '-') // transform multiple - to -
    .replace(/^-|-$/g, ''); // remove - at the beginning or the end
}

export function normalizeDomain(domain: string): string {
  const withoutProtocol = stripProtocol(domain);
  return stripWWW(withoutProtocol);
}

export function normalizeAndTransformSpecialCharsKeepingTld(
  rawDomain: string
): string {
  const { domain, tld } = splitTldFromDomain(rawDomain);
  const normalizedDomain = normalizeDomain(domain);
  const cleanedDomain = transformSpecialCharacters(normalizedDomain);
  return cleanedDomain + tld;
}

export function isValidUrl(domain: string): boolean {
  return domain.split('.').length === 2;
}
